var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResTotalCholesterol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aggt53p95a",
    d: "M0 0h61.98v59.214H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.02)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nip7cu3j8b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aggt53p95a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.98 29.607c0 16.352-13.875 29.607-30.99 29.607S0 45.96 0 29.607C0 13.255 13.875 0 30.99 0s30.99 13.255 30.99 29.607",
    fill: "#E7EBFE",
    mask: "url(#nip7cu3j8b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.01 65c-8.746 0-16.937-3.298-23.066-9.287a1.342 1.342 0 0 1-.033-1.88 1.299 1.299 0 0 1 1.853-.034c5.637 5.51 13.182 8.544 21.246 8.544 8.043 0 15.574-3.02 21.207-8.504a1.3 1.3 0 0 1 1.853.038c.502.53.486 1.372-.038 1.88C49.91 61.718 41.732 65 33.01 65",
    fill: "#738DFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 29.607c0 9.768 4.954 18.428 12.588 23.82h36.804c7.634-5.392 12.588-14.052 12.588-23.82 0-4.028-.845-7.866-2.37-11.365H4.37A28.373 28.373 0 0 0 2 29.607",
    fill: "#738DFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.412 50.112C42.5 45.918 37.741 43.37 32.61 43.37c-5.131 0-9.89 2.548-12.803 6.742h-9.16c.744.74 1.526 1.444 2.347 2.107h39.992a30.84 30.84 0 0 0 2.346-2.107h-9.92zM62.128 19.45H3.893c-.263.69-.493 1.394-.703 2.107h16.638C22.74 25.751 27.499 28.3 32.63 28.3c5.132 0 9.89-2.548 12.803-6.742H62.83c-.21-.713-.44-1.417-.703-2.107",
    fill: "#D8DFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.673 35.166c0 1.535-1.228 2.78-2.742 2.78-1.513 0-2.741-1.245-2.741-2.78 0-1.535 1.228-2.78 2.741-2.78 1.514 0 2.742 1.245 2.742 2.78M10.766 35.166c0 1.535-1.227 2.78-2.741 2.78s-2.742-1.245-2.742-2.78c0-1.535 1.228-2.78 2.742-2.78s2.741 1.245 2.741 2.78M17.21 42.04c0 1.534-1.228 2.779-2.742 2.779-1.513 0-2.741-1.245-2.741-2.78 0-1.535 1.228-2.78 2.741-2.78 1.514 0 2.742 1.245 2.742 2.78M18.99 29.433c0 1.535-1.227 2.78-2.74 2.78-1.514 0-2.742-1.245-2.742-2.78 0-1.534 1.228-2.78 2.741-2.78 1.514 0 2.742 1.246 2.742 2.78M43.801 35.166c0 1.535-1.227 2.78-2.741 2.78s-2.741-1.245-2.741-2.78c0-1.535 1.227-2.78 2.741-2.78s2.741 1.245 2.741 2.78M52.27 27.508c0 1.535-1.227 2.78-2.74 2.78-1.514 0-2.742-1.245-2.742-2.78 0-1.535 1.228-2.78 2.741-2.78 1.514 0 2.742 1.245 2.742 2.78M58.158 39.26c0 1.534-1.228 2.78-2.741 2.78-1.514 0-2.742-1.246-2.742-2.78 0-1.535 1.228-2.78 2.742-2.78 1.513 0 2.74 1.245 2.74 2.78",
    fill: "#FFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResTotalCholesterol);
export default __webpack_public_path__ + "static/media/resTotalCholesterol.828b4e8164bba0ac4a41dfc81a6dff29.svg";
export { ForwardRef as ReactComponent };